/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  avatar: null,
  algoliaKey: null,
  merchants: [],
  merchantLocations: [],
  selectedMerchant: null // show statistics for this selected merchant
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js